module.exports = __webpack_public_path__ + "static/media/cancel.ee0835a4.svg";